import React from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faMobile } from '@fortawesome/free-solid-svg-icons';
import '../../styles/modals/AppDownloadModal.css';

const AppDownloadModal = ({ isOpen, onClose, title = 'Download the Yesod App', message = 'RSVP from the Yesod app' }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div className="app-download-modal-overlay" onClick={handleOverlayClick}>
      <div className="app-download-modal" onClick={(e) => e.stopPropagation()}>
        <div className="app-download-modal-header">
          <h2 className="app-download-modal-title">{title}</h2>
          <button className="app-download-modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        
        <div className="app-download-modal-content">
          <div className="app-download-modal-icon">
            <FontAwesomeIcon icon={faMobile} size="3x" />
          </div>
          
          <p className="app-download-modal-message">
            {message}
          </p>
          
          {/* Download Buttons */}
          <div className="download-buttons">
            <a
              href="https://apps.apple.com/us/app/yesod/id6748472269"
              target="_blank"
              rel="noopener noreferrer"
              className="download-button ios-button"
            >
              <img 
                src="/assets/AppStore.png"
                alt="App Store"
                className="download-icon"
              />
              <span className="download-text">Download for iOS</span>
            </a>
            
            <a
              href="https://play.google.com/store/apps/details?id=us.yesod.app"
              target="_blank"
              rel="noopener noreferrer"
              className="download-button android-button"
            >
              <img 
                src="/assets/Googleplay.png"
                alt="Google Play"
                className="download-icon"
              />
              <span className="download-text">Download for Android</span>
            </a>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AppDownloadModal;